import type { Theme } from '@mui/material';
import { Box, Typography } from '@mui/material';
import type { FC } from 'react';
import { getCompoundTestIdGenerator } from '~/utils/getCompoundTestIdGenerator';

type BadgeColor = keyof Pick<Theme['palette'], 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'>;

type ActionBadgeProps = {
  label: string;
  color?: BadgeColor;
  isDarkText?: boolean;
  bgColor?: string;
  hasBorder?: boolean;
};

export const ActionBadge: FC<ActionBadgeProps> = ({
  label,
  color = 'error',
  isDarkText = false,
  hasBorder = false,
  bgColor,
  ...props
}) => {
  const getCompoundTestId = getCompoundTestIdGenerator('actionBadge');

  const getBackgroundColor = ({ palette }: Theme) => {
    if (bgColor) {
      return bgColor;
    }

    return palette[color].main;
  };

  const getTextColor = ({ palette }: Theme) => (isDarkText ? palette.common.black : palette.common.white);

  return (
    <Box
      data-testid={getCompoundTestId('label')}
      component="span"
      bgcolor={getBackgroundColor}
      color={getTextColor}
      borderRadius={({ spacing }) => spacing(12.5)}
      border={hasBorder ? ({ palette }) => `2px solid ${palette.common.white}` : 'none'}
      paddingX={({ spacing }) => spacing(0.75)}
      display="inline-flex"
      justifyContent="center"
      alignItems="center"
      {...props}
    >
      <Typography variant="overline">{label}</Typography>
    </Box>
  );
};
